import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'

import './index.css'
import ErrorBoundary from './components/ErrorBoundary.jsx'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import { store,persistor } from './redux/store.js'
import { PersistGate } from 'redux-persist/integration/react'
import { clearStorageIfNewBrowserSession } from './CommonMethods/authSession'

// Before any app code runs: if browser was closed and reopened, session cookie is gone → clear auth storage
clearStorageIfNewBrowserSession()

ReactDOM.createRoot(document.getElementById('root')).render(
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
            <BrowserRouter>
                <ErrorBoundary>
                    <App />
                </ErrorBoundary>
            </BrowserRouter>
        </PersistGate>
    </Provider>
    

)
